import { render, staticRenderFns } from "./DeclartaionSrc.vue?vue&type=template&id=14146590"
import script from "./DeclartaionSrc.vue?vue&type=script&lang=js"
export * from "./DeclartaionSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports